<template lang="pug">
action-bar-ex(
  :entity="entity"
  :actions="actions"
  @perform="opts => $emit('perform', { ...opts, selection })"
)

  template(#navbar)
    v-tooltip(bottom)
      template(#activator="{ on, attrs }")
        v-btn(
          text
          rounded
          @click="$emit('clearSelection')"
        )
          v-icon(left) mdi-broom
          | Limpar Seleção
      | Desmarca os itens marcados

  template(#right)

    //- MENU DE AÇÕES
    action-bar-ex-menu(
      v-bind="$props"
      left
      @perform="opts => $emit('perform', { ...opts, selection })"
    )

    //- BOTÃO FECHAR
    v-tooltip(bottom)
      template(#activator="{ on, attrs }")
        v-btn(
          icon
          v-bind="attrs"
          v-on="on"
          @click="$emit('clearSelection')"
        )
          v-icon mdi-close
      | Desmarca os itens marcados

</template>

<script>
import ActionBarEx from '@/components/commons/action-bar-ex/ActionBarEx'
import ActionBarExMenu from '@/components/commons/action-bar-ex/ActionBarExMenu'

export default {
  components: {
    ActionBarEx,
    ActionBarExMenu,
  },

  props: {
    site: String,
    eref: String,
    form: Object,
    data: Object,
    entity: Object,

    busy: Boolean,

    /**
     * Visibilidade do filtro, alternada por este botão.
     */
    value: Boolean,

    /**
     * Coleção dos registros selecionados na grade.
     */
    selection: Array,

    /**
     * Ações disponíveis no menu.
     *
     * Esta propriedade recebe um objeto que contém a estrutura de ações organizadas no menu.
     *
     * @type {Object}
     * @property {Array} all - Todas as ações no menu.
     * @property {Array} main - Ações principais no menu.
     * @property {Array} side - Ações secundárias no menu.
     * @property {Array} rest - Outras ações no menu.
     * @property {Array} categories
     *    - Categorias personalizadas no menu, cada uma contendo um nome e um conjunto de ações.
     *
     * @example
     * {
     *   menu: {
     *     all: [...], // Todas as ações da página
     *     main: [...], // Ações principais da página
     *     side: [...], // Ações secundárias da página
     *     rest: [...], // Outras ações da página
     *     categories: [
     *       { name: 'Category1', actions: [...] }, // Categorias personalizadas
     *       { name: 'Category2', actions: [...] },
     *       // ...
     *     ]
     *   },
     *   pins: {
     *     all: [...], // Todas as ações fixadas da página
     *     main: [...], // Ações principais fixadas da página
     *     side: [...], // Ações secundárias fixadas da página
     *     rest: [...], // Outras ações fixadas da página
     *     categories: [
     *       { name: 'Category1', actions: [...] }, // Categorias personalizadas
     *       { name: 'Category2', actions: [...] },
     *       // ...
     *     ]
     *   },
     *   states: {
     *     all: [...], // Todos os monitores de estado da página
     *     main: [...], // Monitores de estado da página
     *     side: [...], // Monitores de estado secundários da página
     *     rest: [...], // Outros monitores de estado da página
     *     categories: [
     *       { name: 'Category1', actions: [...] }, // Categorias personalizadas
     *       { name: 'Category2', actions: [...] },
     *       // ...
     *     ]
     *   }
     * }
     */
    actions: Object,
  },
}
</script>